export default {

    // set items
    setItems(state, items) {
      state.items = items;
    },
  
    // set items remaining
    setItemsRemaining(state, itemsRemaining) {
      state.itemsRemaining = itemsRemaining;
    },
  
    // set item count
    setItemsCount(state, itemsCount) {
      state.itemsCount = itemsCount;
    },
  
    // the amount of results we need to take from the API
    setTake(state, take) {
      state.take = take;
    },

    // set total pages
    setTotalPages(state, totalPages) {
      state.totalPages = totalPages;
    }
  };